module.exports = __webpack_public_path__ + "Frame413-8312a1aa.webp";